<mat-selection-list #matSelection role="list" class="list-jornadas" (selectionChange)="getSelected($event)"
   [formControl]="control">
  <mat-list-option #matOptions *ngFor="let item of dataSourceList" [value]="item">
    {{ item.IdJornada + ' - ' + item.Njornada }}
  </mat-list-option>
</mat-selection-list>
